import React, { useCallback } from 'react';
import { useLocalStorage } from '../../Hooks/useLocalStorage';
import { LOCAL_STORAGE_CONSENT } from '../../Utils/LocalStorage/localStorageKeys';
import { EDCookieSettingsContext } from './CookieSettingsContext';
import {
  CONSENT_NECESSARY,
  CONSENT_NONE,
  IConsent,
} from './CookieSettingsUtils';

let w: any = undefined;
if (typeof window !== 'undefined') {
  w = window;
}

//För att slippa börja varje test med att acceptera cookies. Cypress har också problem med att återställa indexedDB som localForage använder än så länge.
const isCypressTest = !!w.Cypress;

/** Initiera cookie-inställningar när de lästs in från localStorage */
const onLoadConsentSettings = (err: unknown, value: IConsent | null) => {
  if (!err && value != null) {
    gtag('consent', 'update', {
      ad_storage: 'denied', //add storage använder vi inte
      analytics_storage: value.statistics ? 'granted' : 'denied', //cookies för analytics, default denied tills vi frågat användaren eller läst in sparad svar
    });
    w?.Rollbar.configure({ transmit: !!value.errorReports });
  }
};

/** Läs in inställningar för cookies från localStorage */
const useCookieConsentStorage = (): [
  IConsent,
  (consent: IConsent) => void,
  boolean
] => {
  const [consent, setStoredConsent, _, loading] = useLocalStorage<IConsent>(
    LOCAL_STORAGE_CONSENT,
    CONSENT_NONE,
    undefined,
    onLoadConsentSettings
  );
  const setConsent = useCallback(
    (newConsent: IConsent) => {
      if (consent.statistics !== newConsent.statistics) {
        gtag('consent', 'update', {
          ad_storage: 'denied', //add storage använder vi inte
          analytics_storage: newConsent.statistics ? 'granted' : 'denied', //cookies för analytics, default denied tills vi frågat användaren eller läst in sparad svar
        });
      }
      if (consent.errorReports !== newConsent.errorReports) {
        w?.Rollbar.configure({ transmit: !!newConsent.errorReports });
      }
      setStoredConsent(newConsent);
    },
    [consent, setStoredConsent]
  );
  return [isCypressTest ? CONSENT_NECESSARY : consent, setConsent, loading];
};

/** Cookie-inställningarna läsas in till ett globalt kontext. För att hela programmet direkt ska få rätt inställningar när de ändras */
export const EDGlobalCookieContextProvider: React.FC<
  React.PropsWithChildren<{}>
> = props => {
  const value = useCookieConsentStorage();
  const loading = value[2];
  return (
    <EDCookieSettingsContext.Provider value={value}>
      {!loading && props.children}
    </EDCookieSettingsContext.Provider>
  );
};
